import { render } from "./BlankCanvas.vue?vue&type=template&id=09925236&scoped=true"
import script from "./BlankCanvas.vue?vue&type=script&lang=js"
export * from "./BlankCanvas.vue?vue&type=script&lang=js"

import "./BlankCanvas.vue?vue&type=style&index=0&id=09925236&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09925236"]])

export default __exports__